(() => {
  const root=document.documentElement;
  const toggles=[...document.querySelectorAll('[data-theme-toggle]')];
  const themeMeta=document.querySelector('meta[name="theme-color"]');

  function applyTheme(theme,persist=false){
    const next=theme==='dark'?'dark':'light';
    root.dataset.colorTheme=next;
    if(persist){try{localStorage.setItem('aliou-color-theme',next)}catch{}}
    toggles.forEach(button=>{
      const dark=next==='dark';
      button.setAttribute('aria-pressed',String(dark));
      button.setAttribute('aria-label',dark?'Activer le mode clair':'Activer le mode sombre');
      button.title=dark?'Mode clair':'Mode sombre';
    });
    if(themeMeta)themeMeta.content=next==='dark'?'#0b0b0c':'#f6f0e9';
  }

  applyTheme(root.dataset.colorTheme||'light');
  toggles.forEach(button=>button.addEventListener('click',()=>applyTheme(root.dataset.colorTheme==='dark'?'light':'dark',true)));

  document.querySelectorAll('.taxonomy-rail-wrap').forEach(wrapper=>{
    const rail=wrapper.querySelector('[data-content-rail]');
    const previous=wrapper.querySelector('[data-rail-prev]');
    const next=wrapper.querySelector('[data-rail-next]');
    if(!rail||!previous||!next)return;

    const update=()=>{
      previous.disabled=rail.scrollLeft<8;
      next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-8;
    };
    const move=direction=>rail.scrollBy({left:direction*rail.clientWidth*.82,behavior:'smooth'});
    previous.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    rail.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update,{passive:true});
    wrapper.closest('[data-tabs]')?.querySelectorAll('[data-tab]').forEach(tab=>tab.addEventListener('click',()=>requestAnimationFrame(update)));
    update();
  });
})();
